export default {
  page_title: '其他 LII 及资源',
  t_falm: 'FALM 成员',
  t_clic: '社区法网 (CLIC)',
  clicname: 'Community Legal Information Centre',
  liis: [
    "HKLII 参与{0}，参与机构包括：",
    "社区法网是一个双语法律资讯互联网站，市民可透过此网站迅速地寻找有关香港法律的资料。社区法网是由香港大学法律与科技研究中心承办，并由香港特区政府律政司拨款。"
  ],
  fatlm: "法律信息自由取用运动"
}